// extracted by mini-css-extract-plugin
module.exports = {"formReservationJtails":"FormReservation-Jtails_formReservationJtails_3Q0oo"};